/**
 * I-1380: what can wait for the boot's own requests waits for them.
 *
 * Over HTTP/1.1 a browser opens six connections to one host, and requests are served in the order
 * they were asked for. The boot sends the session check and the launch screen's first read, then
 * asks for the launch screen's code (`index.tsx`). Anything a store asks for while the modules are
 * still being evaluated, before the Keychain session is back, is ahead of all of them: the realtime
 * socket's client (two chunks, 174 KB) was, because the attention follow opens when a token is
 * stored. `index.tsx` holds such loads until it has sent its requests; with no boot holding, as in
 * a unit test, nothing waits.
 */
let held: Promise<void> | null = null;

/** Called once by the boot; the returned function lets everything held go. */
export function holdForBootRequests(): () => void {
  let release: () => void = () => undefined;
  held = new Promise<void>((resolve) => {
    release = resolve;
  });
  return () => release();
}

/**
 * Settles once the boot has sent its requests, or at once when no boot holds. Read a microtask
 * late, so a call made while the modules are still being evaluated, before `index.tsx`'s body has
 * run, still sees the boot's hold.
 */
export async function afterBootRequests(): Promise<void> {
  await Promise.resolve();
  await held;
}
